/// Version info
export const VERSION_NUMBER = '1.0.3.48';
// version 1.0.3.48 - Forms - interactive attachments, Dropdowns with values
// version 1.0.3.47 - Config - Live tracking config
// version 1.0.3.46 - Config - material release table - added Description;
// version 1.0.3.45 - Config - added material release table formatter;
// version 1.0.3.44 - Adding PDF to Order & Hide Warehouses config key;
// version 1.0.3.43 - Order numbering config key;
// version 1.0.3.42 - User calendar;
// version 1.0.3.41 - Angular 20;
// version 1.0.3.40 - Angular 19; config supervisor
// version 1.0.3.39 - Angular 18
// version 1.0.3.38 - New UI for tables
// version 1.0.3.37 - Form permissions moved to admin
// version 1.0.3.36 - Branches - master data added
// version 1.0.3.35 - Forms - signature per technician - added
// version 1.0.3.34 - Angular 16.2, config - allow duplicated vat code
// version 1.0.3.33 - Order State
// version 1.0.3.32 - Angular 16
// version 1.0.3.31 - Forms: Device Attachment Groups
// version 1.0.3.30 - Forms - condition in tables
// version 1.0.3.29 - Product Categories Attributes
// version 1.0.3.28 - Aggregate tables
// version 1.0.3.27 - Personal folders
// version 1.0.3.26 - Device Tables
// version 1.0.3.25 - Sequential Order Actions
// version 1.0.3.24 - Surveys: editor
// version 1.0.3.22 - Forms - forms for serviceman
// version 1.0.3.22 - Config - add photo from gallery
// version 1.0.3.21 - New reactive forms
// version 1.0.3.20 - forms - expressions
// version 1.0.3.19 - forms - new permissions
// version 1.0.3.18 - installations attributes & status colors
// version 1.0.3.16 - links in form
// version 1.0.3.15 - dropdown button
// version 1.0.3.14 - user attributes
// version 1.0.3.13 - chains
// version 1.0.3.12 - library - drag&drop
// version 1.0.3.11 - library
// version 1.0.3.10 - forms: empty form allowed / config: no draft
// version 1.0.3.09 - forms: attachments groups
// version 1.0.3.08 - config/ branches
// version 1.0.3.07 - forms: departments assign
// version 1.0.3.06 - Angular 13, form fixes
// version 1.0.3.05 - form types
// version 1.0.3.04 - forms - drawings
// version 1.0.1.03 - new forms
// version 1.0.3.02 - embedded forms
